import './Canvas3.css';

import { Canvas } from '@react-three/fiber';
import { RootState } from '@react-three/fiber/dist/declarations/src/core/store';

export interface CanvasProps {
  onCreated?: (state: RootState) => void;
}

const Canvas3: React.FC<CanvasProps> = (props) => {
  return (
    <Canvas
      {...props}
      camera={{ position: [0, 0, 0], rotation: [0, 0, 0, 'YXZ'], fov: 90 }}
      className="scene-canvas"
    >
      <ambientLight />
      {props.children}
    </Canvas>
  );
};
export default Canvas3;
